import { getBankAccount } from "lib/api/bankAccount/getBankAccount"
import { useQuery } from "@tanstack/react-query"

const useGetBankAccount = (userNo, options) => {
  return useQuery(createKey(userNo), getBankAccount, { ...options })
}

const createKey = (userNo) => ["bank_account", userNo]
useGetBankAccount.createKey = createKey

export default useGetBankAccount
